<template>
  <div class="tab-pane active" id="form-step-3">
    <template v-if="!isSuccess && showThankYou">
        <ThankYou/>
    </template>
    <template v-else>
    <div class="row" v-if="!alreadyVerified && !isSuccess">
      <identity-client
        v-for="(client, index) in userIdentitiesUnverified"
        :key="index"
        :contact="client" @goNext="goNextStep"
      />

      <div class="col-sm-12 mt-3">
        <message-info />
      </div>
   
      <div class="col-sm-12 mt-3 text-center" v-if="!isWidgetMode">
        <p>Haven't got your documentation with you?</p>
        <a href="#" @click.prevent="goNextStep()">Skip this step</a>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-sm-12 mt-3">
        <message-info />
      </div>
    </div>
    <div class="col-sm-12 mt-2">
      <hr />
      <privacy-policy />
    </div>
    </template>
    <Loading v-if="loading" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import Loading from "@/components/ui/Loading.vue";
import IdentityClient from "@/components/ui/IdentityClient.vue";
import axios from "axios";
import mixin from "@/components/shared/mixinUtility";
import ThankYou from "@/components/ui/ThankYou.vue";
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';
export default {
  name: "Account",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      alreadyVerified: false,
      currContactId: null,
      isSuccess: false,
      showThankYou: false,
    };
  },
  computed: {
    ...mapGetters({
      contactId: "getContactId",
      additionalContactId: "getAdditionalContactId",
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      formData: "getFormData",
      userIdentities: "getUserIdentities",
      mainContactId: "getMainContactId",
      jwtToken: "getJwtToken",
      mainGBGStatus: "getMainUserGBGStatus",
      additionalGBGStatus: "getAdditionalUserGBGStatus",
       actions: "getActions",
    }),
    isWidgetMode() {
      return this.$route.name == "kyc";
    },
    userIdentitiesUnverified() {
      return this.userIdentities.filter((user) => !user.alreadyVerified);
    },
  },
  methods: {
    async goNextStep() {
        //if mobile verified and gbg verified they can create an ONline account
        if (
          this.actions.isMobileVerified &&
          this.actions.isGBGVerified
        ) {
           this.loading = true;
          //generate token and redirect to FTL
          const token = await this.generateToken(this.contactId,false);
          //redirect to first time login
          this.$router.push({
            name: "FirstLogin",
            params: { tokenvalue: token },
          });
           this.loading = false;
        } else {
          this.showThankYou=true;
          //redirect to thank you page
          // window.top.location.href =
          //   "https://www.smartcurrencyexchange.com/applyonline/thankyou/";
        }

    },
    async validateToken() {
      try {
        const token = this.$route.params.tokenvalue;
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL + "/client/getTokenDetails?Token=" + token
        );
        if (data.data != null && data.data.validToken) {
          //set contactiD and any additional contact
          await this.$store.dispatch("setContactId", data.data.contactID);
          await this.$store.dispatch("setMainContactId", data.data.contactID);
          //set auth token
          if (data.data.token)
            await this.$store.dispatch(
              "setJwtToken",
              data.data.token.access_token
            );
          if (data.data.additionalUserIds) {
            let addUserIds = data.data.additionalUserIds.split(",");
            if (addUserIds.length > 0)
              await this.$store.dispatch(
                "setAdditionalContactId",
                parseInt(addUserIds[0])
              );
          }
        } else {
          this.showGenericErrorMessage("Your link is no longer valid.", false);
          this.isSuccess = true;
        }
      } catch (ex) {
        this.loading = false;
        this.showGenericErrorMessage("We've encountered a problem.", false);
        return false;
      }
    },
    async getGBGStatus(currContactId, isMain) {
      try {
        //this is only in widget mode
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL +
            `/client/getGBGVerificationstatus?contactId=${currContactId}&mainContactId=${this.mainContactId}`,
          { headers: { Authorization: `Bearer ${this.jwtToken}` } }
        );

        const status = data.data.verificationstatus.toLowerCase();
        if (isMain) await this.$store.dispatch("setMainUserGBGStatus", status);
        else await this.$store.dispatch("setAdditionalUserGBGStatus", status);
      } catch (ex) {
        this.loading = false;
        this.showGenericErrorMessage("We've encountered a problem.", false);
      }
    },
    async setIdentityClient(currContactId, status, isMain) {
      //init user documentation object
      let result = {
        contactId: currContactId,
        alreadyVerified: false,
        showPOA: false,
        showIDdoc: false,
        isMain: isMain,
      };

      if (status == "verified" || status == "invalid") {
        result.alreadyVerified = true;
      } else if (
        status == "reverify" ||
        status == "iddoc-poa" ||
        status == "na"
      ) {
        //show both ID docs upload/POA upload
        result.showPOA = true;
        result.showIDdoc = true;
      } else if (status == "poa" || status == "hide") {
        result.showPOA = true;
      } else if (status == "iddoc") {
        result.showIDdoc = true;
      }
      if (isMain && result.alreadyVerified)
        this.$store.dispatch("setGBGVerified", true);

      return result;
    },
    async doAlreadyVerified() {
      //skip the step automatically
      if (this.isWidgetMode) {
        //show some nice message
        this.showGenericErrorMessage(
          "Your account has already been verified.",
          true
        );
        this.alreadyVerified = true;
      } else {
        await this.goNextStep();
      }
      this.loading = false;
    },
  },
  components: {
    Loading,
    MessageInfo,
    "identity-client": IdentityClient,
    ThankYou,
 "privacy-policy": PrivacyPolicy,
   },
  watch: {
    async mainGBGStatus() {
      if (this.mainGBGStatus != "") {
        console.log("watch");
        //call status API or just pass status
        let mainRes = await this.setIdentityClient(
          this.contactId,
          this.mainGBGStatus,
          true
        );
        await this.$store.dispatch("addUserIdentity", mainRes);
        //check if user is already verified
        if (mainRes.alreadyVerified) {
          await this.doAlreadyVerified();
        }
          this.loading = false;
      }
    },
    
  },
  async created() {
    this.resetMessageInfo();
    this.$store.dispatch("setHideNavigation", true);
    
    if (this.isWidgetMode) {
      this.loading = true;
      //validate token and set contactId Info
      await this.validateToken();
      //check gbgStatus
      await this.getGBGStatus(this.contactId,true);
      if (this.additionalContactId != null)
        await this.getGBGStatus(this.additionalContactId,false);
    }

    if (this.mainGBGStatus == "")
      //gbg still loading
      this.loading = true;
    else {
      //already got response from GBG
      let mainRes = null;
      if (this.contactId != null) {
        mainRes = await this.setIdentityClient(
          this.contactId,
          this.mainGBGStatus,
          true
        );

        //check if user is already verified
        if (mainRes.alreadyVerified ) {
          //skip the step automatically
          await this.doAlreadyVerified();
        }

        await this.$store.dispatch("addUserIdentity", mainRes);
      }
     
    }
  },
};
</script>
<style>
.font-13 {
  font-size: 13px !important;
}
</style>